import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SetupField from '../setupField/setupField';
import AppearanceSetupModal from './appearanceSetupModal';
import { useTheme } from '../context/ThemeContext';
import { useDisplaySize } from '../../context/DisplaySizeContext';
import { getThemeTranslation } from '../../constants/utilityFunctions';
import { useThemeColor } from '../../context/ThemeColorContext';
import { DISPLAY_SIZE_LABEL_KEYS } from '../../utils/displaySize';
import { THEME_COLOR_LABEL_KEYS } from '../../utils/themeColor';
import { ThemeColorDot } from '../../assets/styles/components/featureBox';

const AppearanceSetupField = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [themeMode] = useTheme();
  const { displaySize } = useDisplaySize();
  const { themeColor } = useThemeColor();

  const label = t('common:profile.appearance');
  const value = `${getThemeTranslation(themeMode, t)} - ${t(DISPLAY_SIZE_LABEL_KEYS[displaySize])}`;

  return (
    <>
      <SetupField
        label={label}
        icon={<ThemeColorDot className="flex-shrink-0" aria-hidden="true" />}
        value={value}
        // The dot is the only place the accent colour shows, so screen readers hear its name here.
        aria-label={`${label}: ${value}, ${t(THEME_COLOR_LABEL_KEYS[themeColor])}`}
        isOpen={isOpen}
        aria-haspopup="dialog"
        onClick={() => setIsOpen(true)}
        data-testid="appearance-setup-field"
      />
      <AppearanceSetupModal open={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

export default AppearanceSetupField;
